import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function templateReducer(
  state = initialState.templates,
  action
) {
  switch (action.type) {
    case types.LOADING_TEMPLATES:
      return { ...state, status: "loading",deleted:false };
    case types.LOAD_TEMPLATES_SUCCESS:
      return {
        ...state,
        list: [...state.list, ...action.templates],
        status: "succeeded",
      };
    case types.GET_TEMPLATE_SUCCESS:
      return {
        ...state,
        currentTemplate: action.template,
        status: "succeeded",
        updated: false,
      };
    case types.SAVE_TEMPLATE_SUCCESS:
      return {
        ...state,
        currentTemplate: action.template,
        status: "succeeded",
      };
    case types.UPDATE_TEMPLATE_SUCCESS:
      return {
        ...state,
        currentTemplate: {},
        status: "succeeded",
        updated: true,
      };
    case types.DELETE_TEMPLATE_SUCCESS: {
      const isCurrentTemplate = action.templateId == state.currentTemplate.id;
      return {
        ...state,
        currentTemplate: isCurrentTemplate ? {} : state.currentTemplate,
        status: "succeeded",
        deleted: true,
      };
    }
    case types.API_TEMPLATE_ERROR:
      return { ...state, error: action.error, status: "failed" };
    default:
      return state;
  }
}
